/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathNot = createReactComponent("math-not", "IconMathNot", [
  ["path", { d: "M5 12h14v4", key: "svg-0" }]
]);

export { IconMathNot as default };
//# sourceMappingURL=IconMathNot.js.map
